export default function initials(val: string, count: number = 2): string {
	let words: string[] = val.split(' ')
	let initials: string = ''
	for (let i = 0; i < Math.min(words.length, count); i++) {
		initials += words[i].charAt(0)
	}
	return initials
}
